import { render, staticRenderFns } from "./NewFileUploadModule.vue?vue&type=template&id=3b6613ce&scoped=true"
import script from "./NewFileUploadModule.vue?vue&type=script&lang=js"
export * from "./NewFileUploadModule.vue?vue&type=script&lang=js"
import style0 from "./NewFileUploadModule.vue?vue&type=style&index=0&id=3b6613ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6613ce",
  null
  
)

export default component.exports